export const EXCHANGE_HOLIDAYS = "EXCHANGE_HOLIDAYS";
export const EXCHANGE_HOLIDAYS_ERROR = "EXCHANGE_HOLIDAYS_ERROR";
export const EXCHANGE_HOLIDAYS_HIDE_ERROR = "EXCHANGE_HOLIDAYS_HIDE_ERROR";
export const EXCHANGE_HOLIDAYS_START_LOADER = "EXCHANGE_HOLIDAYS_START_LOADER";
export const EXCHANGE_HOLIDAYS_STOP_LOADER = "EXCHANGE_HOLIDAYS_STOP_LOADER";
